define('formkit/view/form/form.object.type.menu/form.object.type.menu.composite.view',['require','exports','module','uikit/uikit','../../../templates','./form.object.type.menu.item.view'],function(require, exports, module) {
  var UIKit                  = require('uikit/uikit');
  var Templates              = require('../../../templates');
  var FormObjectMenuItemView = require('./form.object.type.menu.item.view');

  var FormObjectMenuCompositeView = UIKit.CompositeView.extend({

    template: Templates.App['form.object.type.menu.composite'],

    className: 'form-object-type-menu',

    options: {
      headerText: 'Objects',
      form: null
    },

    childView: FormObjectMenuItemView,

    childViewContainer: '.form-object-types',

    childViewEventPrefix: 'formObjectTypes',

    childViewOptions: function() {
      return {
        form: this.form
      }
    },

    internalViewOptions: {
      headerView: function() {
        return {
          type: UIKit.Header,
          tagName: 'h5'
        }
      }
    },

    internalViewBindings: {
      headerView: {
        text: 'headerText'
      }
    }

  });

  module.exports = FormObjectMenuCompositeView;
});

